export default {
  title: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  dob: "",
  businessRole: ""
};
